import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import * as actions from '../../actions';
import * as c from '../../constants';
import { getSelectedTabKey } from '../../selectors';

import AddTab from './TabPanelAddItem';


class TabPanelItem extends Component {
  constructor(props) {
    super(props);

    this.handleOnTabClick = this.handleOnTabClick.bind(this);
    this.handleOnAddClick = this.handleOnAddClick.bind(this);
    this.handleOnEditClick = this.handleOnEditClick.bind(this);
    this.handleOnDeleteClick = this.handleOnDeleteClick.bind(this);
    this.handleOnActiveToggle = this.handleOnActiveToggle.bind(this);
  }


  handleOnActiveToggle(event) {
    event.stopPropagation();

    const { item, toggleTabActive } = this.props;
    toggleTabActive(item);
  }


  handleOnAddClick() {
    const { showAddModal } = this.props;
    showAddModal(c.MODAL_MODE_ADD_TAB);
  }


  handleOnEditClick(event) {
    event.stopPropagation();

    const { item, editHotkey } = this.props;
    const { active } = item;

    active
    && editHotkey(item, c.MODAL_MODE_EDIT_TAB);
  }


  handleOnDeleteClick(event) {
    event.stopPropagation();

    const { item, deleteTab } = this.props;
    const { active } = item;

    active
    && deleteTab(item);
  }


  handleOnTabClick() {
    const { item, onTabClick } = this.props;
    const { active } = item;

    active
    && onTabClick
    && onTabClick(item);
  }


  render() {
    const { isSelected, item: { key, name, active, is_template_group } } = this.props;
    const height = 40;

    if (key === c.ADD_DOC_ID) {
      return <AddTab label={name} height={height} onClick={this.handleOnAddClick} />;
    }

    return (
      <div className={`ui link ${isSelected && 'blue'} card ht-card ${!active && 'gray'}`} style={{ height }} onClick={this.handleOnTabClick}>
        <div className="content" style={{ padding: 5 }}>
          <div className="ui checkbox" onClick={this.handleOnActiveToggle}>
            <input readOnly type="checkbox" checked={Boolean(active)} style={{ pointerEvents: 'none' }} />
            <label></label>
          </div>
          <div className="ui right floated" onClick={this.handleOnEditClick}>
            <i className="ui large edit icon"></i>
          </div>
          <div className="center aligned description ht-group-name" data-content={name} data-tooltip={name} data-position="left center" >
            {name}
          </div>
          {is_template_group &&
            <div className="ui right floated" onClick={this.handleOnDeleteClick}>
              <i className="ui large remove icon" />
            </div>
          }
        </div>
      </div>
    );
  }
}


function mapStateToProps(state, ownProps) {
  const selectedKey = getSelectedTabKey(state);
  const { item: { key_level: tabKey } } = ownProps;

  return {
    isSelected: selectedKey === tabKey
  };
}


function mapDispatchToProps(dispatch) {
  const { toggleTabActive, deleteTab, editHotkey, showAddModal } = actions;

  return bindActionCreators({
    editHotkey,
    deleteTab,
    showAddModal,
    toggleTabActive
  }, dispatch);
}


export default connect(mapStateToProps, mapDispatchToProps)(TabPanelItem);
